
import { Component, Vue, Prop, Watch, InjectReactive, Inject } from "vue-property-decorator"

import { get, set } from "lodash"

// @ts-ignore
import { Datetime } from "vue-datetime"
import vSelect from "vue-select"

import {
	getEnhancedMapping,
	IEnhancedMapping,
	IMap,
	IMarker,
	ILatLng,
	ILatLngBounds
} from "@sureview/v2-mapping"

import { Field } from "@/types"

import { MapProvider, MarkerDrawType } from "@/services/mapProvider"

	@Component({
		components: {
		}
	})
export default class MapLocation extends Vue {
	$refs!: {
		mappingContainer: HTMLElement,
	}

	@Inject("mapProvider") mapProvider!: MapProvider;

	@Prop()
	value!: any;

	@Prop()
	fieldId!: string;

	@Prop()
	title!: string;

	@Prop()
	fieldType!: string;

	@Prop()
	fieldExtensions!: any;

	@Prop()
	readonly!: boolean;

	get map (): IMap | null {
		return this.mapProvider && this.mapProvider.map ? this.mapProvider.map! : null
	}

	get markerIcon (): string {
		return this.fieldExtensions && this.fieldExtensions.markerColor ? this.fieldExtensions.markerColor : "red"
	}

	get drawType (): MarkerDrawType {
		switch (this.fieldType) {
			case "map-region": return MarkerDrawType.Region
			case "map-path": return MarkerDrawType.Path
			default: return MarkerDrawType.Point
		}
	}

	@Watch("value")
	valueChanged () {
		this.mapProvider.drawValue(this.fieldId, this.drawType, this.title, this.markerIcon, this.value)
	}

	mounted () {
		if (this.value) {
			this.mapProvider.drawValue(this.fieldId, this.drawType, this.title, this.markerIcon, this.value)
		}
	}

	beforeDestroy () {
		this.mapProvider.drawValue(this.fieldId, this.drawType, this.title, this.markerIcon, [])
	}

	setLocation () {
		if (this.mapProvider && this.mapProvider.mapElement) {
			this.mapProvider.startDraw({
				colorName: this.markerIcon,
				color: "",
				drawType: this.drawType,
				markerText: this.title,
				set: (value: any) => {
					const newValue = this.value ? [...this.value, value] : [value]
					this.$emit("input", newValue)
					this.mapProvider.drawValue(this.fieldId, this.drawType, this.title, this.markerIcon, newValue)
				},
				cancel: () => {

				}
			})
		}
	}

	gotoLocation (location: any) {
		if (this.map) {
			this.mapProvider.goto(location)
		}
	}

	removeLocation (location: any) {
		if (this.value) {
			this.$emit("input", this.value.filter((v: any) => v !== location))
		}
	}
}

